import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, Close } from '@mui/icons-material';
import {
  Nav,
  NavContainer,
  Logo,
  LogoImage,
  NavLinks,
  NavLink,
  MobileMenuButton,
  MobileMenu,
  MobileMenuHeader,
  MobileNavLink
} from './styles';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Nav>
      <NavContainer>
        <Logo to="/">
          <LogoImage src="/images/logo.png" alt="אפיק לב - ייעוץ משכנתאות" />
          אפיק לב
        </Logo>

        <NavLinks>
          <NavLink to="/" className={location.pathname === '/' ? 'active' : ''}>
            דף הבית
          </NavLink>
          <NavLink to="/about" className={location.pathname === '/about' ? 'active' : ''}>
            אודות
          </NavLink>
          <NavLink to="/services" className={location.pathname.includes('/services') ? 'active' : ''}>
            שירותים
          </NavLink>
          <NavLink to="/blog" className={location.pathname === '/blog' ? 'active' : ''}>
            בלוג
          </NavLink>
          <NavLink to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>
            צור קשר
          </NavLink>
          <NavLink to="/calculator" className={location.pathname === '/calculator' ? 'active' : ''}>
            מחשבון משכנתא
          </NavLink>
        </NavLinks>

        <MobileMenuButton onClick={() => setIsMobileMenuOpen(true)}>
          <Menu />
        </MobileMenuButton>

        <MobileMenu isOpen={isMobileMenuOpen}>
          <MobileMenuHeader>
            <Logo to="/" onClick={() => setIsMobileMenuOpen(false)}>
              <LogoImage src="/images/logo.png" alt="אפיק לב - ייעוץ משכנתאות" />
              אפיק לב
            </Logo>
            <MobileMenuButton onClick={() => setIsMobileMenuOpen(false)}>
              <Close />
            </MobileMenuButton>
          </MobileMenuHeader>

          <MobileNavLink to="/" onClick={() => setIsMobileMenuOpen(false)}>
            דף הבית
          </MobileNavLink>
          <MobileNavLink to="/about" onClick={() => setIsMobileMenuOpen(false)}>
            אודות
          </MobileNavLink>
          <MobileNavLink to="/services" onClick={() => setIsMobileMenuOpen(false)}>
            שירותים
          </MobileNavLink>
          <MobileNavLink to="/blog" onClick={() => setIsMobileMenuOpen(false)}>
            בלוג
          </MobileNavLink>
          <MobileNavLink to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
            צור קשר
          </MobileNavLink>
          <MobileNavLink to="/calculator" onClick={() => setIsMobileMenuOpen(false)}>
            מחשבון משכנתא
          </MobileNavLink>
        </MobileMenu>
      </NavContainer>
    </Nav>
  );
}

export default Navbar; 